import { useState } from 'react';
import { debounce } from "@mui/material";
import { IconSearchCustom } from '../Theme/IconMUI';
import { SearchIconWrapper, SearchStyle, StyledInputBase } from "../Theme/SearchStyle";

export const SearchSingle = ({onChange, className}) => {
  const [inputValue, setInputValue] = useState("");
  const [focused, setFocused] = useState(false)

  const debouncedOnChange = debounce((value) => {
    onChange(value);
  }, 500);

  const handleInputChange = (event) => {
    const { value } = event.target;
    setInputValue(value);  
    debouncedOnChange(value.toLowerCase()); 
  };

  return (
    <SearchStyle onFocused={focused} className={className}> 
      <SearchIconWrapper>
        <IconSearchCustom/>
      </SearchIconWrapper>
      <StyledInputBase
                value={inputValue}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                placeholder="Cerca…"
                inputProps={{ 'aria-label': 'search' }}
                onChange={handleInputChange}/>
    </SearchStyle> 
  ) 
};
